import React from 'react';
import {SessionManager} from '../../../utilities/session-management/session-manager';
import i18n from '../../../utilities/i18n';

export const LogoutButton = () => (
  <button className="logout-btn" onClick={() => SessionManager.endSession()}>{i18n.t('felles:loggUt')}</button>
);
